module.exports = __webpack_public_path__ + "img/app-logo.a016ffee.png";